import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=b2774a0c"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=b2774a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports